/* eslint-disable no-restricted-syntax, no-console */
import { useContext, useCallback } from "react";
import get from "lodash.get";
import { compensationValues, formatCurrency } from "config/currencies";
import { getCurrencyFromLanguage } from "config/currencies/currencyUtils";
import logger from "@airhelp/node-logger";
import { LocalizationContext } from "./LocalizationContext";

export const useLanguage = () => get(useContext(LocalizationContext), "language", "");

export const useTranslations = () => {
  const translations = get(useContext(LocalizationContext), ["translations"], "");
  return (key, args) => {
    let translation = get(translations, key, key);

    if (typeof args !== "undefined") {
      Object.keys(args).forEach((k) => {
        const reg = new RegExp(k, "g");
        translation = translation.replace(reg, args[k]);
      });
    }

    if (translation === key) {
      if (process.env.NODE_ENV !== "test") {
        logger.info(`KEY: "${key}" - does not exist in the page namespaces`);
      }
    }
    return translation;
  };
};

export const useLocalizedData = () => {
  const language = useLanguage();
  const getLocalizedNumber = useCallback(
    (value) => {
      const locale = language === "en-int" ? "en-us" : language;

      return new Intl.NumberFormat(locale).format(value);
    },
    [language]
  );

  const getLocalizedCurrency = useCallback(
    (value, fixedCurrency, precision) => formatCurrency(value, language, fixedCurrency, precision),
    [language]
  );

  const getCompensationValue = useCallback(
    (type = "compensation", fixedCurrency, precision) => {
      const currency = fixedCurrency ?? getCurrencyFromLanguage(language);
      const compensationValue = compensationValues[currency][type];

      return formatCurrency(compensationValue, language, fixedCurrency, precision);
    },
    [language]
  );

  return { getLocalizedNumber, getLocalizedCurrency, getCompensationValue };
};
